module.exports = __webpack_public_path__ + "img/11-edit.4c71c3f9.svg";